import * as React from "react";
import s from "./PortfolioBenchmarkingModal.module.scss";
import { RoundButton } from "../../../RoundButton/RoundButton";
import FormModal from "../../../FormModal/FormModal";
import { Typography } from "@progress/kendo-react-common";
import InsightShort from "../../../Insights/InsightShort/InsightShort";
import { PortfolioBenchmarkIndexRes } from "@iliotech/generated-api";
import cn from "classnames";
import { useEffect, useState } from "react";
import { RecommendedBenchmark } from "@iliotech/generated-api-v3";
import { useAvailableBenchmarks } from "@iliotech/data-wire";
import { useTranslation } from "react-i18next";
import Loader from "../../../Loader/Loader";
import {
  MultiSelect,
  MultiSelectChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { FaChevronDown } from "react-icons/fa";

interface IProps {
  visible: boolean;
  handleClose: () => void;
  portfolioBenchmarks: string[];
  defaultBenchmarks: RecommendedBenchmark[];
  updateBenchmarks: (items: RecommendedBenchmark[]) => void;
  performanceBenchmarkName: string | undefined;
  loading: boolean;
}

const MAX_BENCHMARKS = 4;

const PortfolioBenchmarkingModal = ({
  visible,
  handleClose,
  updateBenchmarks,
  portfolioBenchmarks,
  defaultBenchmarks,
  loading,
}: IProps) => {
  const indexes = useAvailableBenchmarks().data?.data;
  const [benchmarksChecked, setChecked] = useState(portfolioBenchmarks);
  const [searchString, setSearchString] = React.useState("");

  const comboRef = React.useRef<MultiSelect>(null);

  const { t } = useTranslation();
  const { h3: H3, p: P } = Typography;
  useEffect(() => {
    if (visible) {
      setChecked(portfolioBenchmarks);
    }
  }, [visible, portfolioBenchmarks]);

  const onSave = () => {
    const newBenchmarks: RecommendedBenchmark[] | undefined = benchmarksChecked
      .map((item) => {
        const found = indexes?.find((index) => index.code === item);
        return {
          name: found?.name!,
          ticker: found?.code!,
          description: "",
        };
      })
      .filter((item) => !!item.ticker);
    updateBenchmarks(newBenchmarks);
    handleClose();
  };

  const benchmarksLength = benchmarksChecked.length;

  const onMultiSelect = (e: MultiSelectChangeEvent) => {
    setChecked(
      e.value
        .map((v: PortfolioBenchmarkIndexRes) => v.code)
        .slice(0, MAX_BENCHMARKS)
    );
  };

  return (
    <FormModal
      handleClose={handleClose}
      visible={visible}
      footer={
        <div className={s.footer}>
          <div
            className={cn(s.suggested)}
            onClick={() =>
              setChecked(
                defaultBenchmarks?.map((b) => b.ticker) || portfolioBenchmarks
              )
            }
          >
            Suggested benchmarks
          </div>
          <RoundButton onClick={onSave}>Done</RoundButton>
        </div>
      }
    >
      {loading ? (
        <Loader />
      ) : (
        <>
          <H3>Portfolio benchmarking</H3>
          <div
            className={cn(s.comboSurround)}
            onClick={() => {
              comboRef.current?.focus();
              comboRef.current?.setState({ opened: true });
            }}
          >
            <MultiSelect
              ref={comboRef}
              data={
                indexes
                  ?.filter((t) =>
                    t.name.toUpperCase().includes(searchString.toUpperCase())
                  )
                  .sort((a, b) => a.name.localeCompare(b.name)) ?? []
              }
              textField={"name"}
              onFilterChange={(event) => {
                setSearchString(event.filter.value);
              }}
              style={{
                border: "none",
                borderRight: "1px solid rgba(0,0,0,0.25)",
              }}
              filterable={true}
              onChange={onMultiSelect}
              value={indexes?.filter((index) =>
                benchmarksChecked.includes(index.code)
              )}
            />
            <div className={cn(s.chevronSurround)}>
              <FaChevronDown />
            </div>
          </div>
          <div
            className={cn(
              s.selectedCount,
              benchmarksLength >= MAX_BENCHMARKS && s.maxedOut
            )}
          >
            {benchmarksLength}/{MAX_BENCHMARKS} BENCHMARKS SELECTED
          </div>
        </>
      )}
    </FormModal>
  );
};

export default PortfolioBenchmarkingModal;
